// extracted by mini-css-extract-plugin
export default {"container":"RiskScore_container__c2ZDD","row":"RiskScore_row__skZds","link":"RiskScore_link__qBPSZ","viewLink":"RiskScore_viewLink__eKEBJ"};